<template>
  <div class="option-item">
    <div class="option" :class="borderClass" @click.stop="goToRoute">
      <div class="icon">
        <img :src="subItemIcon" />
      </div>
      <div class="text">{{ sectionTitle }}</div>
    </div>
  </div>
</template>

<script>
import TextIcon from '../../../public/img/icons/content_icon.png'
import AssessmentIcon from '../../../public/img/icons/exercises_icon.png'
import StudyCardIcon from '../../../public/img/icons/study_cards_icon.png'
import MediaIcon from '../../../public/img/icons/videos_icon.png'
import CPDContentIcon from '../../../public/img/icons/cpd_content_icon.png'
import { mapMutations } from 'vuex'
export default {
  name: 'TOCItem',
  props: ['sectionTitle', 'sectionData', 'chapterName', 'bookTitle'],
  data () {
    return {
      borderClass: 'border-red',
      subItemIcon: '',
      subItemType: '',
      subItemRoute: '',
      TextIcon,
      AssessmentIcon,
      StudyCardIcon,
      MediaIcon,
      CPDContentIcon
    }
  },
  beforeMount () {
    this.setDataByType()
  },
  methods: {
    ...mapMutations({
      setChapterTitle: 'book/SET_CHAPTER_TITLE',
      setChapterHeading: 'book/SET_CHAPTER_HEADING',
      setSectionContent: 'book/SET_SECTION_CONTENT'
    }),
    setDataByType () {
      switch (this.sectionData.$.type) {
        case 'text':
          this.borderClass = 'border-red'
          this.subItemIcon = this.TextIcon
          this.subItemRoute = 'notes'
          break
        case 'assessment':
          this.borderClass = 'border-blue'
          this.subItemIcon = this.AssessmentIcon
          this.subItemRoute = 'assessment'
          break
        case 'study-card':
          this.borderClass = 'border-green'
          this.subItemIcon = this.StudyCardIcon
          this.subItemRoute = 'study-card'
          break
        case 'media':
          this.borderClass = 'border-purple'
          this.subItemIcon = this.MediaIcon
          this.subItemRoute = 'media'
          break
        case 'cpd-content':
          this.borderClass = 'border-gray-2'
          this.subItemIcon = this.CPDContentIcon
          this.subItemRoute = 'cpd-content'
          break
        default:
          break
      }
    },
    goToRoute () {
      this.$gtm.trackEvent({
        event: 'user_clicked_section',
        category: 'TOC',
        action: 'click',
        label: 'User clicked a section',
        productName: this.bookTitle,
        chapterName: this.chapterName,
        sectionTitle: this.sectionTitle
      })

      this.setChapterHeading(this.subItemTitle)
      this.setChapterTitle(this.chapterName)
      this.setSectionContent(this.sectionData.SectionContent[0])

      if (window.location.pathname.startsWith('/proofing')) {
        this.subItemRoute = `proof-${this.subItemRoute}`
      }

      this.$router.push({
        name: this.subItemRoute,
        params: {
          chapter: this.chapterName,
          section: this.sectionTitle
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.option-item {
  .option {
    display: flex;
    border-top-style: solid;
    border-top-width: 3px;
    border-style: solid;
    border-bottom-color: $outline-border-gray;
    border-left-color: $outline-border-gray;
    border-right-color: $outline-border-gray;
    border-bottom-width: 1px;
    border-left-width: 1px;
    border-right-width: 1px;
    cursor: pointer;
    transition: border-color 0.3s;
  }
  .border-red {
    border-top-color: $border-red;
    &:hover {
      border-color: $border-red;
    }
  }
  .border-blue {
    border-top-color: $border-blue;
    &:hover {
      border-color: $border-blue;
    }
  }
  .border-green {
    border-top-color: $border-green;
    &:hover {
      border-color: $border-green;
    }
  }
  .border-purple {
    border-top-color: $border-purple;
    &:hover {
      border-color: $border-purple;
    }
  }
  .border-gray-2 {
    border-top-color: $border-gray-2;
    &:hover {
      border-color: $border-gray-2;
    }
  }

  .border-gray {
    border-top-color: $border-gray;
    &:hover {
      border-color: $border-gray;
    }
  }

  .outline-border-gray {
    border-top-color: $outline-border-gray;
  }

  .icon {
    background-color: #fff;
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      max-height: 42px;
      max-width: 70px;
    }
  }
  .text {
    background-color: $option-items-text-backgroud;
    width: 100%;
    padding: 25px 10px;
    font-size: $SectionTitle;
    font-weight: bold;
    color: $black;
  }
}
</style>
